import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ErrorCategory } from 'src/app/models/error-category';
import { ReportConstants } from 'src/app/models/report-constants';
import { ReportErrorSearchFilter } from 'src/app/models/report-error-search-filter';
import { LTButtonComponent } from 'src/app/features/lt-shared-ui/lt-button/components/lt-button/lt-button.component';

@Component({
  selector: 'app-report-error-search-filter',
  templateUrl: './report-error-search-filter.component.html',
  styleUrls: ['./report-error-search-filter.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    LTButtonComponent,
    DatePipe,
  ],
})
export class ReportErrorSearchFilterComponent implements OnInit {

  @Input() reportConstants: ReportConstants;
  @Input() errorSearchFilter: ReportErrorSearchFilter;

  @Output() updateFilter = new EventEmitter<ReportErrorSearchFilter>();
  @Output() clearGridFilters = new EventEmitter<boolean>();
  @Output() reloadCurrentList = new EventEmitter<boolean>();

  allErrorsReturned = false;
  allErrorsDisplayed = false;
  tabIndex = 0;
  origErrorSearchFilter: ReportErrorSearchFilter;
  //Category Filter
  selectedCategory: ErrorCategory = {
    errorCategoryId: 0,
    categoryName: 'Select a Category',
    categoryDescription: 'Select a Category',
    categoryPriority: 0,
  };

  constructor() {
  }

  ngOnInit(): void {
    this.origErrorSearchFilter = Object.assign({}, this.errorSearchFilter);
    if (this.reportConstants != undefined) {
      this.reportConstants.errorCategories?.push(this.selectedCategory);
    }
  }


  updateFilters(): void {
    if (this.errorSearchFilter.startReceivedDate != undefined)
      this.errorSearchFilter.startReceivedDate = new Date(this.errorSearchFilter.startReceivedDate.toLocaleDateString());
    if (this.errorSearchFilter.endReceivedDate != undefined)
      this.errorSearchFilter.endReceivedDate = new Date(this.errorSearchFilter.endReceivedDate.toLocaleDateString());
    if (this.errorSearchFilter.startInitialErrorDate != undefined)
      this.errorSearchFilter.startInitialErrorDate = new Date(this.errorSearchFilter.startInitialErrorDate.toLocaleDateString());
    if (this.errorSearchFilter.endInitialErrorDate != undefined)
      this.errorSearchFilter.endInitialErrorDate = new Date(this.errorSearchFilter.endInitialErrorDate.toLocaleDateString());
    if (this.errorSearchFilter.startResolutionDate != undefined)
      this.errorSearchFilter.startResolutionDate = new Date(this.errorSearchFilter.startResolutionDate.toLocaleDateString());
    if (this.errorSearchFilter.endResolutionDate != undefined)
      this.errorSearchFilter.endResolutionDate = new Date(this.errorSearchFilter.endResolutionDate.toLocaleDateString());

    this.updateFilter.emit(this.errorSearchFilter);
  }

  formatDateSearchField(event: string): Date {
    let rc: Date = undefined;
    if (event != undefined && event != '') {
      rc = new Date(event);
      if(isNaN(rc.getTime())){
        rc = undefined;
      }
    }
    return rc;
  }

  clearFilters(): void {
    this.selectedCategory = this.reportConstants.errorCategories.find(c => c.errorCategoryId == 0);
    this.errorSearchFilter = Object.assign({}, this.origErrorSearchFilter);
    this.clearGridFilters.emit(true);
    this.updateFilters();
  }

  onTabSelect(event: any): void {
    this.tabIndex = event.index;
  }

  setAllErrorsReturned(): void {
    this.allErrorsReturned = true;
  }

  setAllErrorsDisplayed(): void {
    this.allErrorsDisplayed = true;
  }


  reloadErrorData() {
    this.reloadCurrentList.emit(true);
  }
}
